<template>
    <div>
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document"></i> {{ $t('navMenu.219') }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input
                    v-model="name"
                    :placeholder="$t('translationNouns.searchPlaceholder')"
                    class="handle-input mr10"
                    @keyup.enter.native="handleSearch"
                ></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button class="handle-btn-add" type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}</el-button>
            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column type="index" :label="$t('translationNouns.index')" width="65" align="center"></el-table-column>
                <el-table-column
                    v-for="lang in languages"
                    :key="lang.field"
                    :prop="lang.field"
                    :label="$t('translationNouns.' + lang.field)"
                    align="center"
                    min-width="100"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column :label="$t('common.operation')" align="center" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button size="mini" type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="dialogVisible" width="680px" :before-close="handleClose" top="5vh">
            <el-form ref="form" :model="editForm" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="12" v-for="lang in languages" :key="lang.field">
                        <el-form-item :label="$t('translationNouns.' + lang.field)">
                            <el-input v-model="editForm[lang.field]" :disabled="lang.field === 'zh_CN'"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" @click="editFormData">{{ $t('common.confirm') }}</el-button>
            </span>
        </el-dialog>

        <!-- 新增对话框 -->
        <el-dialog :title="$t('common.add')" :visible.sync="addDialogVisible" width="680px" :before-close="handleAddClose" top="5vh">
            <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="12" v-for="lang in languages" :key="lang.field">
                        <el-form-item :label="$t('translationNouns.' + lang.field)" :prop="lang.field">
                            <el-input v-model="addForm[lang.field]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddClose">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" @click="saveAdd">{{ $t('common.confirm') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiCurrentPermisson,
    apiListTranslationNouns,
    apiAddTranslationNouns,
    apiUpdateTranslationNouns,
    apiDeleteTranslationNouns
} from '@/request/api';

// 语言字段配置（集中管理表格列和表单字段）
const LANGUAGES = [
    { field: 'zh_CN' },
    { field: 'zh_TW' },
    { field: 'en' },
    { field: 'ja' },
    { field: 'ko' },
    { field: 'fr' },
    { field: 'de' },
    { field: 'ru' },
    { field: 'ar' },
    { field: 'ms' },
    { field: 'vi' },
    { field: 'th' },
    { field: 'hi' }
];

export default {
    name: 'translationNouns',
    data() {
        return {
            languages: LANGUAGES,
            addForm: {},
            editForm: {},
            dialogVisible: false,
            addDialogVisible: false,
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: {},
            pageTotal: 0,
            addFormRules: {
                zh_CN: [{ required: true, message: this.$t('translationNouns.zh_CNRequired'), trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.getData();
        this.getPermission();
    },
    activated() {
        this.getData();
        this.getPermission();
    },
    methods: {
        // 编辑操作
        handleEdit(row) {
            this.editForm = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        editFormData() {
            apiUpdateTranslationNouns(this.editForm).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                    this.handleClose();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleClose() {
            this.editForm = {};
            this.dialogVisible = false;
        },
        // 添加操作
        handleAdd() {
            this.addForm = {};
            this.addDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
            });
        },
        saveAdd() {
            this.$refs.addFormRef.validate((valid) => {
                if (!valid) return;
                apiAddTranslationNouns(this.addForm).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success(this.$t('translationNouns.addSuccess'));
                        this.addDialogVisible = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });
        },
        handleAddClose() {
            this.addForm = {};
            this.addDialogVisible = false;
        },
        // 删除操作
        handleDelete(row) {
            this.$confirm(this.$t('translationNouns.confirmDelete'), this.$t('common.warning'), {
                type: 'warning'
            })
                .then(() => {
                    apiDeleteTranslationNouns({ zh_CN: row.zh_CN }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success(this.$t('translationNouns.deleteSuccess'));
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取列表数据
        getData() {
            this.$load.show();
            apiListTranslationNouns({
                page: this.pageIndex,
                page_size: this.pageSize,
                seek: this.name
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            this.$load.close();
        },
        // 获取页面权限
        getPermission() {
            apiCurrentPermisson({ id: '219' }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 搜索
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        // 分页
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}
.handle-input {
    width: 300px;
}
.handle-btn-add {
    margin-left: auto;
}
.table {
    width: 100%;
    font-size: 14px;
}
.mr10 {
    margin-right: 10px;
}
</style>
